// SHEventCard.js
import React from 'react';
import './SHAnnouncementCard.css';
import { TbCalendarMonth, TbUser } from 'react-icons/tb';

const SHAnnouncementCard = ({
    imageSrc,
    title,
    subtitle,
    type,
    creator,
    date,
    onClick
}) => (
    <div className="sh-announcement-card" onClick={onClick}>
        <div className="sh-image-wrapper">
            <img src={imageSrc} alt={title} className="sh-card-image" />
            <span className="sh-announcement-card-type-badge">{type}</span>
        </div>
        <div className="sh-card-content">
            <span className="sh-announcement-title">{title}</span>
            <div className="sh-description">
                <span>{subtitle}</span>
            </div>
            <div className="sh-announcement-card-footer">
                <div className="sh-footer-item">
                    <TbUser className="sh-icon" />
                    <span>{creator}</span>
                </div>
                <div className="sh-footer-item">
                    <TbCalendarMonth className="sh-icon" />
                    <span>{date}</span>
                </div>
            </div>
        </div>
    </div>
);

export default SHAnnouncementCard;
